<template>
<div class="chapter">
<div class="inner_page">
<div id="otherbooksby">
<h2 class="left">Books by Margaret Moore</h2>
<p class="noindent">Harlequin Historicals<br/><br/></p>
<p class="noindent"><sup>*</sup> <i>A Warrior’s Heart</i> #118</p>
<p class="noindent"><i>China Blossom</i> #149</p>
<p class="noindent"><sup>*</sup> <i>A Warrior’s Quest</i> #175</p>
<p class="noindent"><sup>†</sup> <i>The Viking</i> #200</p>
<p class="noindent"><sup>*</sup> <i>A Warrior’s Way</i> #224</p>
<p class="noindent"><i>Vows</i> #248</p>
<p class="noindent"><sup>†</sup> <i>The Saxon</i> #268</p>
<p class="noindent"><sup>*</sup> <i>The Welshman’s Way</i> #295</p>
<p class="noindent"><sup>*</sup> <i>The Norman’s Heart</i> #311</p>
<p class="noindent"><sup>*</sup> <i>The Baron’s Quest</i> #328</p>
<p class="noindent"><sup>‡</sup> <i>The Wastrel</i> #344</p>
<p class="noindent"><sup>‡</sup> <i>The Dark Duke</i> #364</p>
<p class="noindent"><sup>‡</sup> <i>The Rogue’s Return</i> #376</p>
<p class="noindent"><sup>∇</sup> <i>The Knights of Christmas</i> #387</p>
<p class="noindent"><sup>*</sup> <i>A Warrior’s Bride</i> #395</p>
<p class="noindent"><sup>*</sup> <i>A Warrior’s Honor</i> #420</p>
<p class="noindent"><sup>*</sup> <i>A Warrior’s Passion</i> #440<br/><br/></p>
<p class="noindent"><sup>*</sup> Warrior Series</p>
<p class="noindent"><sup>†</sup> The Viking Series</p>
<p class="noindent"><sup>∇</sup> In-line Christmas Collection</p>
<p class="noindent"><sup>‡</sup> Most Unsuitable…</p>
<p class="noindent">Harlequin Books<br/><br/></p>
<p class="noindent"><i>Mistletoe Marriages</i></p>
<p class="noindent">“Christmas in the Valley”</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-otherbooksby.vue?3507065e